module.exports = __webpack_public_path__ + "img/auth-fon.560da431.jpg";